export default "__VITE_ASSET__56715e54__"